

























import Vue from 'vue';
import upgradeVuex from '../vuex/common';
import { Time } from '../models/Fee';

export default Vue.extend({
  mixins: [upgradeVuex],
  data() {
    return {
      Time,
      showZero: false,
    };
  },
  watch: {
    'upgrade.level'() {
      this.check();
    },
  },
  methods: {
    selectTime(time: number) {
      this.$store.commit('UPDATE_TIME', time);
    },
    check() {
      if (this.accountState.crmLevel) {
        this.showZero = this.upgrade.level !== this.accountState.fansLevel && (this.accountState.crmLevel.modules.length === this.upgrade.modules.length || (this.accountState.crmLevel.modules.length === 3 && this.upgrade.isAll));
      }
    },
  },
  mounted() {
    this.check();
  },
});
